import { ImageBlockProps } from "../../../ui/organisms/ImageBlock"
import { TextBlockProps } from "../../../ui/organisms/TextBlock"

export const toImageBlockProps = (item: any): ImageBlockProps => ({
  image: item.image?.asset,
  imageWidth: item.imageWidth,
  imageAlign: item.imageAlign,
  subtitle: item.subtitle,
})

export const toTextBlockProps = (item: any): TextBlockProps => ({
  text: item.text,
})
